App.filter('dateFormatterWithShortNameDay', function () {
    return function (miliSec) {
        miliSec = miliSec || '';
        if (miliSec) {
        	var time = new Date(miliSec);
            
            var day = time.getDate();

            var nameOfDay = nameDay(time.getDay());

            if (day < 10) {
            	day = '0' + day;
            }
            var month = time.getMonth() + 1;
            if (month < 10) {
            	month = '0' + month;
            }
            var year = time.getFullYear();

            var all = nameOfDay + ' ' + day + '.' + month;
        }
        return all;

        function nameDay(numberOfDay) {
        	var array = new Array(7);
        	array[1] = 'Pon';
			array[2] = 'Wt';
			array[3] = 'Śr';
			array[4] = 'Czw';
			array[5] = 'Pt';
			array[6] = 'Sob';
			array[0] = 'Nd';

			return array[numberOfDay];
        }
    };
})